const solutions = {
  title: '行业解决方案',
  subtitle: '针对不同行业特点，提供定制化的支付解决方案',
  painPoints: '行业痛点',
  solutionTitle: '解决方案',
  benefits: '价值收益',
  caseStudies: '成功案例',
  caseStudiesDesc: '以下为示例案例，实际案例详情请联系获取',
  challenge: '挑战：',
  result: '结果：',
  ctaTitle: '找到适合您的解决方案',
  ctaSubtitle: '我们的专家团队将为您量身定制最优的支付策略',
  ctaButton: '免费咨询',
  industries: {
    ecommerce: {
      title: '电商出海',
      subtitle: 'DTC/平台商家',
      painPoints: [
        '多地区支付偏好差异',
        '拒付与风控挑战',
        '结算效率低下',
        '本地化体验不足'
      ],
      solutions: [
        '统一 API 接入多种支付方式',
        '本地支付组合优化',
        '智能风控策略模板',
        '实时汇率与结算'
      ],
      benefits: [
        '提升转化率 15-30%',
        '降低拒付率 40%',
        '加速回款周期',
        '提升用户体验'
      ],
      cta: '对接电商方案'
    },
    gaming: {
      title: '游戏/数字内容',
      subtitle: '游戏娱乐平台',
      painPoints: [
        '微支付高频交易',
        '套利风险控制',
        '订阅/内购管理',
        '多平台支付统一'
      ],
      solutions: [
        '低额高频交易优化',
        '多层风险分层策略',
        '充值卡/钱包接入',
        '订阅管理系统'
      ],
      benefits: [
        '提升用户留存率',
        '增加 ARPU 值',
        '降低运营成本',
        '优化付费体验'
      ],
      cta: '咨询游戏方案'
    },
    fintech: {
      title: '金融/交易平台',
      subtitle: '金融科技服务',
      painPoints: [
        '洗钱合规要求',
        '资金通道稳定性',
        '对账核对复杂',
        '监管合规成本'
      ],
      solutions: [
        'KYC/AML 流程嵌入',
        '通道多活架构',
        '自动对账工具',
        '合规报告生成'
      ],
      benefits: [
        '降低合规风险',
        '减少运维成本',
        '提升资金安全',
        '简化审计流程'
      ],
      cta: '联系合规顾问'
    },
    saas: {
      title: '跨境 SaaS',
      subtitle: '订阅服务平台',
      painPoints: [
        '跨币种订阅扣款失败',
        '税费处理复杂',
        '发票管理困难',
        '续费率优化'
      ],
      solutions: [
        '本地化支付选项',
        '智能重试机制',
        '自动账单生成',
        '订阅生命周期管理'
      ],
      benefits: [
        '提升订阅成功率',
        '增加续费率',
        '简化财务流程',
        '优化现金流'
      ],
      cta: '获取订阅方案'
    }
  },
  cases: [
    {
      company: '某跨境电商平台',
      industry: '电商',
      challenge: '东南亚市场支付转化率低',
      result: '接入本地钱包后转化率提升 25%',
      metrics: '月交易量 $2M+'
    },
    {
      company: '某手游发行商',
      industry: '游戏',
      challenge: '内购支付成功率不稳定',
      result: '优化支付流程后成功率达 98%',
      metrics: 'DAU 500K+'
    },
    {
      company: '某 SaaS 服务商',
      industry: 'SaaS',
      challenge: '订阅续费率偏低',
      result: '本地化支付选项提升续费率 30%',
      metrics: '订阅用户 10K+'
    }
  ]
};

export default solutions;